import type { AssistantInfo } from "../../../services/api/instances/assistantsApi/types";
import { TrashIcon } from "../../../shared/icons/TrashIcon";
import { TDirection } from "../types";

export const DIRECTIONS: TDirection[] = ["left", "top", "right", "bottom"];

export const ASSISTANT_INITIAL_VALUE: AssistantInfo = {
  description: "",
  instructions: "",
  metadata: {
    education_page: "custom_assistant",
    dialogs: "false",
  },
  model: "free",
  name: "",
  reasoning_effort: null,
  response_format: "auto",
  temperature: 0.5,
  tools: [
    {
      type: "code_interpreter",
    },
  ],
  tool_resources: { code_interpreter: { file_ids: [] } },
  top_p: 1,
};

export const ASSISTANT_JSON_VIEW = [
  "assistant_object",
  "name",
  "instructions",
  "model",
  "response_format",
  "temperature",
  "tools",
  "function",
  "tool_resources",
  "file_search",
  "vector_store_ids",
];

export const ASSISTANT_SETTINGS_MENU_OPTIONS = [
  {
    option_name: "instruction",
    title: "Инструкция вызова",
  },
  // {
  //   option_name: "model",
  //   title: "Модель",
  // },
  // {
  //   option_name: "knowledge_base",
  //   title: "База знаний",
  // },
  // {
  //   option_name: "temperature",
  //   title: "Температура",
  // },
  // {
  //   option_name: "functions",
  //   title: "Функции",
  // },
  {
    option_name: "delete",
    title: "Удалить",
    icon: <TrashIcon />,
  },
];

export const ASSISTANT_PLUGIN = {
  type: "function",
  function: {
    name: "plugin_call_external_assistant",
  },
};

export const SKILLS_PLUGIN = {
  type: "function",
  function: {
    name: "plugin_call_skill",
  },
};

export const DICTIONARY_SKILLS = {
  "business-analitics--ascii-process-schema": "Рисовальщик схем",
  "business-analitics--bottleneck-finder": "Поиск бутылочных горлышек",
  "business-analitics--digital-thinking-analysis": "Выявляет скрытые артефакты",
  "business-roles--ceo-advisor": "Стратегический советник для CEO",
  "business-roles--cto-advisor": "Технологический советник для CTO",
  "business-roles--finance-manager": "Финансовый менеджер",
  "business-roles--hr-manager": "HR-менеджер",
  "business-roles--marketing-manager": "Маркетинговый менеджер",
  "business-roles--operations-manager": "Операционный менеджер",
  "business-roles--product-manager": "Продакт менеджер",
  "business-roles--sales-manager": "Менеджер по продажам",
  "methodology--humanitarian-critic": "Гуманитарий-критик",
  "methodology--methodologist": "СМД методолог",
  "methodology--programmer-critic": "Код ревью критик",
  "test-secret-code": "Тест секретный код",
};
